<template>
    <div
        class="search-group low"
        :class="{filled, disabled, focused}"
        @click="focus"
    >
        <div class="icon-ic-magnifier icon" v-if="!hideIcon" />

        <input
            :id="name"
            type="text"
            :name="name"
            :disabled="disabled"
            :placeholder="placeholder"
            :autofocus="autofocus"
            :autocomplete="autocomplete"

            class="search-input"

            v-bind:value="value"
            @input="$emit('input', $event.target.value)"
            @focus="setFocused"
            @blur="setBlurred"

            ref="input"
            :size="size"
        >
        <button
            v-if="searchButton || clearButton"
            type="button"
            class="icon-ic-dismiss clear-search"
            @click="clear"
            :title="$t('general.clear')"
        />

        <div class="border" v-if="searchButton"/>

        <button
            v-if="searchButton"
            type="button"
            class="icon-ic-magnifier search-button"
            @click="$emit('apply')"
            :title="$t('general.search')"
        />
    </div>
</template>

<script>
export default {
    props: ['value', 'placeholder', 'name', 'disabled', 'size', 'autofocus', 'hideIcon', 'clearButton', 'searchButton', 'autocomplete'],

    data () {
        return {
            focused: false,
            error: null
        }
    },

    computed: {
        filled () {
            return (this.value && this.value.trim().length > 0);
        }
    },

    methods: {
        clear () {
            this.$emit('input', '');
            this.$emit('cleared')
        },

        focus () {
            this.$refs.input.focus()
        },

        setFocused () {
            this.focused = true;

            this.$emit('focus', '');
        },

        setBlurred () {
            this.focused = false;

            this.$emit('blur', '');
        }
    }
}
</script>

<style scoped lang="postcss">
.search-group {
    padding: 0;
    height: 48px;
    align-items: stretch;

    &.h-40 {
        height: 40px;
    }
}


.search-input {
    padding: 12px 0 12px 12px;
}

.border {
    margin: 8px 0;
    width: 1px;
    background-color: var(--color-cases-gray-4);
    border-radius: 2px;
    display: flex;
    opacity: 0;
    transition: opacity 0.25s ease;
}

.clear-search,
.search-button {
    width: 48px;
}

.clear-search {
    background: none;
    color: var(--color-cases-gray-3);
    transition: color 0.15s ease,
                transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);

    font-size: 14px;
    border-radius: 0;

    flex-basis: 48px;
    height: auto;
    transform: scale(0.3);

    &:hover,
    &:focus {
        color: var(--color-cases-gray-0);
    }
}

.search-button {
    color: var(--color-cases-blue);
    font-size: 19px;
    background: none;
    border: none;
    outline: none;
    border-radius: 0;
    transition: color 0.15s ease;


    &:hover,
    &:focus {
        color: var(--color-cases-text);
    }
}

.filled {
   .border {opacity: 1}
   .clear-search {transform: scale(1);}
}
</style>
